// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { LoadMoreButton } from "#/components/load_more_button/LoadMoreButton";
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { NewsListModuleItem } from "./item/NewsListModuleItem";
import { News } from "#/common/interfaces/News";
import { Pagination } from "@mgs/ci2019-common/src/models/pagination/Pagination";

// Services
import { Api } from "#/api";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    NewsListModuleItem,
    LoadMoreButton,
  },
})
export class NewsListModule extends ModuleBase {
  /*public blocks: Array<any> = [];*/
  public news: Array<any> = [];

  public allNews: News[] = [];
  public pagination: Pagination | null = null;

  public weightedBlockItemCounts = [3, 4, 6];
  public currentPage = 0;
  public loadMoreButtonIsLoading = false;
  public totalCount = 13;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  public created() {
    this.loadNews(0);
  }

  get canLoadMore() {
    return this.instance.hasOwnProperty("limit") && this.instance["limit"] <= 0;
  }

  get epp() {
    if (this.instance.hasOwnProperty("limit") && this.instance["limit"] <= 0) {
      return this.instance["type"] == "weighted" ? 13 : 12;
    } else {
      return this.instance.hasOwnProperty("limit")
        ? this.instance["limit"]
        : 12;
    }
  }

  get showLoadMoreButton() {
    return (
      this.pagination &&
      this.canLoadMore &&
      (this.pagination.page_number + 1) * this.pagination.epp <
        this.pagination.total
    );
  }

  public async loadNews(page) {
    this.loadMoreButtonIsLoading = true;
    let news = await Api.pageService.getNews(
      this.$store.page.page!.portal.id,
      this.epp,
      page
    );
    this.loadMoreButtonIsLoading = false;
    this.pagination = news.pagination!;
    this.allNews = this.allNews.concat(news.resultList);
  }

  public async loadMore() {
    this.loadNews(this.pagination!.page_number + 1);
  }

  get blocks() {
    let news = this.allNews;

    if (news.length <= 4) {
      let type = news.length === 3 ? 0 : 1;
      return [{ type: type, items: news }];
    }

    let blockNumber = 0;
    let blocks: any = [];

    let tmpBlock: any = null;

    for (let i = 0; i < news.length; i++) {
      if (tmpBlock === null) tmpBlock = { type: blockNumber, items: [] };

      tmpBlock["items"].push(news[i]);
      if (
        tmpBlock["items"].length === this.weightedBlockItemCounts[blockNumber]
      ) {
        blockNumber++;
        if (blockNumber > 2) blockNumber = 0;

        blocks.push(tmpBlock);
        tmpBlock = null;
      }
    }

    if (tmpBlock !== null) {
      blocks.push(tmpBlock);
    }

    return blocks;
  }
}
